export default {
      id: "aure-one-front-usage",
      viewBox: "0 0 1191 842",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#aure-one-front",
      toString: function () {
        return this.url;
      }
    }